var styles = {"box":"Search_box_1lidy_1","icon":"Search_icon_1lidy_25","input":"Search_input_1lidy_33"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
